import Inspector from './inspector';
const { RichText } = wp.blockEditor;

export default ({ attributes, setAttributes }) => {
  const {
    title,
    titleTag,
    variant,
    align,
    color,
    margin,
    containerized,
    anchor,
    maxWidth,
  } = attributes;

  return (
    <>
      <Inspector attributes={attributes} setAttributes={setAttributes} />

      <div className={`only-text heading-block ${color} ${maxWidth}`}>
        <div
          className={`only-text__content ${containerized ? 'Container' : ''}`}
          id={anchor}
        >
          <RichText
            tagName={titleTag}
            className={`Typography ${variant} ${align} ${margin}`}
            value={title}
            placeholder={`Título  (tag ${titleTag})`}
            keepPlaceholderOnFocus
            onChange={(title) => setAttributes({ title })}
          />
        </div>
      </div>
    </>
  );
};
